import { cx } from '@linaria/atomic';
import type { CommonHTMLAttributes } from '@frontend/types';
import { fullscreenModalBody } from './fullscreen-modal.styles';

type Props = CommonHTMLAttributes & {
  children: React.ReactNode;
  className?: string;
};

export const FullscreenModalBody = ({ children, className, ...rest }: Props) => {
  return (
    <div className={cx(fullscreenModalBody, className)} {...rest}>
      {children}
    </div>
  );
};
